import { PointerMove } from "kido/pointer"
import { Raf } from "kido/raf"
import { damp } from "kido/utils"

const SVG_DEFAULT = ``
const SVG_DRAG = ``

export class Cursor {
  private el: HTMLDivElement
  private svgWrap: HTMLDivElement
  private pointer: PointerMove
  private raf: Raf

  private tx = -100
  private ty = -100
  private cx = -100
  private cy = -100

  constructor() {
    this.el = document.createElement("div")
    this.el.className = "cursor"

    this.svgWrap = document.createElement("div")
    this.svgWrap.className = "cursor_svg"
    this.svgWrap.innerHTML = SVG_DEFAULT
    this.el.appendChild(this.svgWrap)

    document.body.appendChild(this.el)

    this.pointer = new PointerMove({
      cb: (x: number, y: number) => {
        this.tx = x
        this.ty = y
      },
    })

    this.raf = new Raf("cursor", () => this.loop())
  }

  init(): void {
    this.pointer.on()
    this.raf.run()
  }

  private loop(): void {
    this.cx = damp(this.cx, this.tx, 0.15)
    this.cy = damp(this.cy, this.ty, 0.15)
    // Subtract scroll offset — pageY includes native scroll but fixed elements don't
    const sy = window.scrollY || 0
    const sx = window.scrollX || 0
    this.el.style.transform = `translate3d(${this.cx - sx}px, ${this.cy - sy}px, 0)`
  }

  setDrag(on: boolean): void {
    if (on) {
      this.svgWrap.innerHTML = SVG_DRAG
      this.el.classList.add("cursor--drag")
    } else {
      this.svgWrap.innerHTML = SVG_DEFAULT
      this.el.classList.remove("cursor--drag")
    }
  }
}
